import { render, staticRenderFns } from "./InventoryTubesChart.vue?vue&type=template&id=01f99d6e&scoped=true&"
import script from "./InventoryTubesChart.vue?vue&type=script&lang=js&"
export * from "./InventoryTubesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f99d6e",
  null
  
)

export default component.exports